import React, { useContext } from 'react';
import { string, bool } from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { ComponentPlaceholder } from '@thd-olt-component-react/loading-placeholder';

const FBTPlaceholder = ({ color, showLoadingAnimation }) => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';
  return (
    <ComponentPlaceholder
      height={isMobile ? 400 : 250}
      rows={isMobile ? 9 : 5}
      color={color}
      showLoadingAnimation={showLoadingAnimation}
    />
  );
};

FBTPlaceholder.propTypes = {
  color: string,
  showLoadingAnimation: bool
};

FBTPlaceholder.defaultProps = {
  color: '#E0E0E0',
  showLoadingAnimation: false
};

export { FBTPlaceholder };